import React from 'react'
import { M_Table } from 'src/M_Components'

const location = ({ roles }) => {
  return (
    <M_Table entityName={'location'} rolePermissions={roles} />
  )
}

export default location

